import { ComponentSettings } from "../settings/settings";

const settings = {
  text: {
    mainNavigation: {
      de: "Hauptnavigation",
      en: "Main navigation",
      nl: "Hoofdnavigatie",
    },
    switchCustomer: {
      de: "Kunde wechseln",
      en: "Switch customer",
      nl: "Klant wijzigen",
    },
    collapseNavigation: {
      de: "Navigation einklappen",
      en: "Collapse navigation",
      nl: "Navigatie inklappen",
    },
    expandNavigation: {
      de: "Navigation ausklappen",
      en: "Expand navigation",
      nl: "Navigatie uitklappen",
    },
    closeNavigation: {
      de: "Navigation schließen",
      en: "Close navigation",
      nl: "Navigatie sluiten",
    },
    customers: {
      de: "Kunden",
      en: "Customers",
      nl: "Klanten",
    },
    search: {
      de: "Suche",
      en: "Search",
      nl: "Zoeken",
    },
    noCustomersFound: {
      de: "Keine Kunden gefunden",
      en: "No customers found",
      nl: "Geen klanten gevonden",
    },
    modules: {
      de: "Module",
      en: "Modules",
      nl: "Modules",
    },
    omDataHandling: {
      de: "OM Module - Datenverarbeitung",
      en: "OM Modules - Data Handling",
      nl: "OM Modules - Gegevensverwerking",
    },
    rmDataHandling: {
      de: "RM Module - Datenverarbeitung",
      en: "RM Modules - Data Handling",
      nl: "RM Modules - Gegevensverwerking",
    },
    account: {
      de: "Konto",
      en: "Account",
      nl: "Account",
    },
    data: {
      de: "Daten",
      en: "Data",
      nl: "Gegevens",
    },
    support: {
      de: "Support",
      en: "Support",
      nl: "Ondersteuning",
    },
    toggleOmDataHandling: {
      de: "OM Datenverarbeitung umschalten",
      en: "Toggle OM data handling",
      nl: "OM gegevensverwerking in-/uitschakelen",
    },
    toggleRmDataHandling: {
      de: "RM Datenverarbeitung umschalten",
      en: "Toggle RM data handling",
      nl: "RM gegevensverwerking in-/uitschakelen",
    },
    cases: {
      de: "Fälle",
      en: "Cases",
      nl: "Gevallen",
    },
    OM: {
      de: "Obsoleszenz Management",
      en: "Obsolescence Management",
      nl: "Obsolescence Management",
    },
    RM: {
      de: "Risiko Management",
      en: "Risk Management",
      nl: "Risk Management",
    },
    profile: {
      de: "Benutzerprofil",
      en: "User Profile",
      nl: "Gebruikersprofiel",
    },
    users: {
      en: "User Management",
      de: "Benutzermanagement",
      nl: "Gebruikersbeheer ",
    },
    charts: {
      de: "Statistik",
      en: "Charts",
      nl: "Grafieken",
    },
    searchInComponent: {
      de: "Suche in Komponentendatenbank",
      en: "Search from Component Database",
      nl: "Zoeken in de database met componenten",
    },
    notification: {
      de: "Benachrichtigungen",
      en: "Notifications",
      nl: "Notificaties",
    },
    logout: { de: "Abmelden", en: "Logout", nl: "Afmelden" },
    import: {
      de: "Daten importieren",
      en: "Import Data",
      nl: "Gegevens importeren",
    },
    export: {
      de: "Exportiere...",
      en: "Export...",
      nl: "Exporteren...",
    },
    help: {
      de: "Hilfe",
      en: "Help",
      nl: "Help",
    },
    helpInfo: {
      de: "Hilfreiche Informationen",
      en: "Helpful Information",
      nl: "Handige informatie",
    },
    info: {
      de: "Unter den folgenden Links finden Sie nützliche Informationen über unsere App",
      en: "In the links bellow you can find useful information about our app",
      nl: "Onder de volgende links vindt u handige informatie over onze app",
    },
    poweredBy: {
      de: "- angetrieben von",
      en: "- powered by",
      nl: "- mogelijk gemaakt door",
    },
    and: {
      de: "und",
      en: "and",
      nl: "en",
    },
  },
  url: {},
  field: {},
  list: {},
  permission: { seeClientName: false },
  additionalInfo: {},
};

export const sidebar: ComponentSettings<typeof settings> = settings;
